import { IClickEventData } from 'types/analytics';

export const getStringFieldAnalytics = (fieldName: string): IClickEventData => ({
    location: 'page',
    category: 'interaction',
    action: `Type your value - ${fieldName}`,
});

export const getOpenDropdownAnalytics = (fieldName: string): IClickEventData => ({
    location: 'page',
    category: 'interaction',
    action: `Open selector - ${fieldName}`,
});

export const getSelectDropdownAnalytics = (fieldName: string): IClickEventData => ({
    location: 'page',
    category: 'interaction',
    action: `Select - ${fieldName}`
});

export const getDateAnalytics = (fieldName: string): IClickEventData => ({
    location: 'page',
    category: 'interaction',
    action: `Type your date - ${fieldName}`,
});
